import {FC, ReactElement, ReactNode} from 'react';
//mui
import {
	Dialog as MuiDialog,
	DialogProps,
	DialogTitle,
	IconButton,
	DialogContent,
	Box,
	DialogContentText,
	SxProps,
	Theme,
} from '@mui/material';
//icons
import {ReactComponent as CheckedErrorIcon} from '@icons/close_big.svg';
//types
import {DefaultButtonColor, DefaultButtonVariants} from '@/utils/types';
//constants
import {CLOSE, OUTLINE, SAVE} from '@/utils/constants';
//components
import Button from '../Button';
//style
import {modalStyle} from './Modal.styles';

export interface ExtendedDialogProps extends DialogProps {
	onClose: () => void;
	onSave?: () => void;
	title?: string;
	description?: string;
	mainIcon?: ReactElement;
	hideCloseIcon?: boolean;
	isShowCloseButton?: boolean;
	closeButtonTitle?: string;
	closeButtonVariant?: DefaultButtonVariants;
	isShowSaveButton?: boolean;
	isSaveButtonDisable?: boolean;
	mainButtonTitle?: string;
	parentClassName?: SxProps<Theme>;
	color?: DefaultButtonColor;
	children?: ReactNode;
	isButtonsBottom?: boolean;
	fullScreen?: boolean;
}

const Modal: FC<ExtendedDialogProps> = ({
	color,
	isShowCloseButton,
	hideCloseIcon,
	closeButtonTitle,
	mainButtonTitle,
	isShowSaveButton,
	isSaveButtonDisable,
	closeButtonVariant,
	children,
	title,
	description,
	mainIcon,
	parentClassName,
	onClose,
	onSave,
	isButtonsBottom,
	fullScreen,
	...rest
}) => {
	return (
		<Box sx={{...modalStyle.wrapper, ...parentClassName}}>
			<MuiDialog {...rest} fullWidth onClose={onClose} fullScreen={fullScreen}>
				<Box sx={isButtonsBottom ? modalStyle.contentWrapper : null}>
					{!hideCloseIcon && (
						<IconButton aria-label={CLOSE} onClick={onClose} sx={modalStyle.modalIconClose}>
							<CheckedErrorIcon />
						</IconButton>
					)}

					{mainIcon && <Box sx={modalStyle.modalIcon}>{mainIcon}</Box>}

					<DialogContent sx={modalStyle.modalContent}>
						{title && <DialogTitle sx={modalStyle.modalContentTitle}>{title}</DialogTitle>}

						{description && <DialogContentText sx={modalStyle.modalContentText}>{description}</DialogContentText>}

						{children}
					</DialogContent>

					{(isShowCloseButton || isShowSaveButton) && (
						<Box sx={isButtonsBottom ? modalStyle.actionsBottom : modalStyle.actions}>
							{isShowCloseButton && (
								<Button
									title={closeButtonTitle || CLOSE}
									color={color}
									variant={closeButtonVariant || OUTLINE}
									sx={modalStyle.buttonClose}
									onClick={onClose}
									disableRipple
								/>
							)}

							{isShowSaveButton && (
								<Button
									title={mainButtonTitle || SAVE}
									sx={modalStyle.buttonSave}
									color={color}
									onClick={onSave}
									disabled={isSaveButtonDisable}
									disableRipple
								/>
							)}
						</Box>
					)}
				</Box>
			</MuiDialog>
		</Box>
	);
};

export default Modal;
